import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'safeTenantName'
})
export class SafeTenantNamePipe implements PipeTransform {

  constructor(private readonly translateService: TranslateService) { }
  
  transform(name: string): string {
    return name ? name : this.translateService.instant('AUTH.UNNAMED_TENANT');
  }

}
